import { useMemo } from "react";
import useToggle from "./useToggle";

export default function useHFC(ancillaryData) {
  const {
    isOpen: isHFCDialogOpen,
    handleOpen: handleHFCDialogOpen,
    handleCancel: handleHFCDialogCancel,
  } = useToggle();

  const { HFC: hfcData } = useMemo(
    () => ancillaryData.find((tool) => !!tool.HFC) || {},
    [ancillaryData]
  );

  return {
    hfcData,
    isHFCDialogOpen,
    handleHFCDialogOpen,
    handleHFCDialogCancel,
  };
}
